<app-header [brokerId]="broker.brokerId"></app-header>
<main>
  <router-outlet></router-outlet>
</main>

<app-footer [brokerId]="broker.brokerId" [ngClass]="{'qd': broker.brokerId == '04'}"></app-footer>
